import React from 'react';
import styled from 'styled-components';
import { FlexBox } from '../../../styles/tabContainers';

interface IContainer {
  children: React.ReactNode;
}

export const Container = styled(({ children, ...props }: IContainer) => (
  <FlexBox justify='flex-end' alignContent='flex-end' wrap='wrap' {...props}>
    {children}
  </FlexBox>
))`
  @media (max-width: 576px), (max-height: 412px) {
    justify-content: flex-start;
  }
  .anticon {
    line-height: 0;
    font-size: 18px;
    margin-right: 8px;
  }
`;
